import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';

const includeFiles = new Map();
const requestInclude = async (src, mode = 'cors') => {
  if (includeFiles.has(src)) {
    return includeFiles.get(src);
  }
  else {
    const request = fetch(src, { mode: mode }).then(async (response) => {
      return {
        ok: response.ok,
        status: response.status,
        html: await response.text(),
      };
    });
    includeFiles.set(src, request);
    return request;
  }
};

const includeCss = ":host{display:block}";

const Include = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.slLoad = createEvent(this, "sl-load", 7);
    this.slError = createEvent(this, "sl-error", 7);
    this.html = '';
    this.src = undefined;
    this.mode = 'cors';
    this.allowScripts = false;
  }
  handleSrcChange() {
    this.loadSource();
  }
  componentWillLoad() {
    this.loadSource();
  }
  executeScript(script) {
    // Create a copy of the script and swap it out so the browser executes it
    const newScript = document.createElement('script');
    [...script.attributes].map((attr) => newScript.setAttribute(attr.name, attr.value));
    newScript.textContent = script.textContent;
    if (script.parentNode) {
      script.parentNode.replaceChild(newScript, script);
    }
  }
  async loadSource() {
    try {
      const src = this.src;
      const file = await requestInclude(src, this.mode);
      // If the src changed since the request started do nothing, otherwise we risk overwriting a subsequent response
      if (src !== this.src) {
        return;
      }
      if (!file) {
        return;
      }
      if (!file.ok) {
        this.slError.emit({ status: file.status });
        return;
      }
      this.element.innerHTML = file.html;
      if (this.allowScripts) {
        [...this.element.querySelectorAll('script')].map((script) => this.executeScript(script));
      }
      this.slLoad.emit();
    }
    catch (_a) {
      this.slError.emit();
    }
  }
  render() {
    return h("slot", null);
  }
  get element() { return this; }
  static get watchers() { return {
    "src": ["handleSrcChange"]
  }; }
  static get style() { return includeCss; }
}, [1, "sl-include", {
    "src": [1],
    "mode": [1],
    "allowScripts": [4, "allow-scripts"],
    "html": [32]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["sl-include"];
  components.forEach(tagName => { switch (tagName) {
    case "sl-include":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, Include);
      }
      break;
  } });
}

const SlInclude = Include;
const defineCustomElement = defineCustomElement$1;

export { SlInclude, defineCustomElement };
